import React from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { AddEditProjectForm } from "../../components/project";
import { PageHeader } from "../../components/v3";

export const AddEditProject = () => {
  const { id } = useParams();

  return (
    <PageLayout>
      {/* header section */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader
          // title
          title={id ? "Edit Project" : "Add Project"}
        />
      </Box>

      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <AddEditProjectForm projectId={id} />
      </Box>
    </PageLayout>
  );
};
